// const baseUrl = "http://192.168.40.147:8089/"; // 本地
const baseUrl = "http://www.scjxrc.org.cn/api/"; // 在线
export const ip = baseUrl; //生产地址
// export const URL = "http://192.168.40.147:8089/"; // 图片地址前缀
export const URL = "http://www.scjxrc.org.cn/static/"; // 图片地址前缀
export const codeURL = ip + "index/loginAdmin/getVerify"; // 登录图形验证码
export const uploadURL = ip + "web/file/system/upload"; // 上传地址
